import React, { FunctionComponent } from 'react';

import { SectorCard as SectorCardType } from '@gojob/cms';
import Icon from '@gojob/ui-bits/Cta/Icon';
import Flex from '@gojob/ui-bits/Flex';
import useTheme from '@gojob/ui-bits/styles/useTheme';
import Text from '@gojob/ui-bits/Text';
import Typograhy from '@gojob/ui-bits/Typography';
import ellispis from 'polished/lib/mixins/ellipsis';

import Link from '../Link';

export interface SectorCardProps extends SectorCardType {
  className?: string;
}

const useStyles = () => {
  const { spacing, colors, boxShadow } = useTheme();

  return {
    root: {
      borderRadius: spacing(4),
      boxShadow: boxShadow('shadow', 2),
      backgroundColor: colors.white,
      padding: spacing(3, 4),
      width: spacing(42),
      maxWidth: '100%',
      textDecoration: 'none',
      transition: 'box-shadow 150ms ease-in',
      outline: 'none',
      border: 0,
      'a&:hover, a&:focus': {
        boxShadow: boxShadow('shadow', 4),
      },
    },
    line: {
      textAlign: 'left',
      margin: spacing(1.5, 0),
      ...ellispis('100%'),
    },
    icon: {
      marginRight: spacing(1),
      marginLeft: spacing(-1.5),
    },
  } as const;
};

const SectorCard: FunctionComponent<SectorCardProps> = (props) => {
  const { title, professions = [], href, internalRef, className, icon } = props;
  const classes = useStyles();

  return (
    <Flex
      as={Link}
      css={classes.root}
      href={href}
      to={internalRef?.slug?.current}
      flexDirection="column"
      className={className}
      aria-label={title}
    >
      <Typograhy css={{ marginTop: 0 }} as="h3" variant="headline3" color="primary" gutter={4}>
        <Flex alignItems="center">
          {icon?.type && <Icon type={icon?.type} css={classes.icon} color="secondary" size={8} />}
          {title}
        </Flex>
      </Typograhy>
      <Flex width="100%" maxWidth="100%" flexDirection="column" margin={[-1.5, 0]}>
        {professions.map((profession, index) => {
          return (
            <Text css={classes.line} key={index} color="textDefault">
              {profession}
            </Text>
          );
        })}
      </Flex>
    </Flex>
  );
};

export default SectorCard;
